<template>
  <div :id="data.id" class="flex flex-col gap-2">
    <UiAccordeon v-for="(group, ig) in data.items" :key="ig">
      <template #title>
        <span v-html="group.name" />
      </template>

      <div class="flex flex-col gap-2 text-sm leading-[1.225rem] sm:gap-4">
        <div
          v-for="(feature, i) in group.features"
          :key="i"
          class="grid-gap-4 sm:grid sm:grid-cols-[33%_1fr] xl:grid-cols-[28%_1fr]"
        >
          <h3 class="font-bold" v-html="feature.name" />

          <div v-html="feature.value"></div>
        </div>
      </div>
    </UiAccordeon>
  </div>
</template>

<script setup lang="ts">
interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>
